import { getChromeProfileEmail } from '@shared/extension/utils/chrome-profile';
import { captureSentryMessage, safeSentryCaptureException, setSentryUser } from '@shared/sentry';
import { Services } from '../services';
import { getEmailFromUserDetails } from './get-email-from-user-details';
import { getStudyReelEmail } from './get-study-reel-email';
import { loadInitialUserDetails, startRefreshingUserDetails } from './load-user-details';
import { LogLevel } from '@environment/enums/log-level.enum';

export async function processProfileEmail(services: Services): Promise<void> {
  try {
    captureSentryMessage(
      'processProfileEmail called',
      {
        envUserEmail: services.environment.userEmail,
        studyReelUrl: services.environment.studyReelUrl,
      },
      LogLevel.Info
    );
    const emailFromUserDetails: string | null = await getEmailFromUserDetails();
    console.log(`Email from user details: ${emailFromUserDetails}`);
    const chromeProfileEmail: string | null = await getChromeProfileEmail();
    const profileEmail: string =
      (await getStudyReelEmail(services.environment.studyReelUrl)) ||
      emailFromUserDetails ||
      chromeProfileEmail ||
      services.environment.userEmail;
    console.log(`Profile email: ${profileEmail}`);

    if (!profileEmail) {
      console.warn('Profile email could not be determined.');
    }

    await services.commonStore.setProfileEmail(profileEmail);
    setSentryUser(profileEmail);
    captureSentryMessage(`Set profile email in store and for Sentry: ${profileEmail}`, {}, LogLevel.Info);

    await loadInitialUserDetails(services);
    startRefreshingUserDetails(services);
  } catch (ex: unknown) {
    const error = new Error(`Error processing profile email: ${ex}`);
    console.error(error);
    safeSentryCaptureException(error);
  }
}
